<ng-template #informationModalForm let-modal>
  <div class="modal-body text-center">
    <div>
      <div class="text-center">
        <div class="mb-4">
          <lord-icon
            [colors]="colors"
            [src]="animationLink"
            style="width:120px;height:120px"
            trigger="loop"
          >
          </lord-icon>
        </div>
        <h4 class="mb-3"><span [innerHtml]="mainMessage"></span></h4>
        <p class="text-muted mb-4"><span [innerHtml]="subMessage"></span></p>
      </div>
    </div>
    <div class="hstack gap-2 justify-content-center">
      <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="closeForm()">Close</button>
    </div>
  </div>
</ng-template>
